/**
 * @description Ações relacionadas a manipulação de casos no sistema
 * @author Bene Lemuel Dantas Gondim
 * @file casosActions.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import axios from 'utils/axios'
import { criarAlerta } from 'actions'

export const DOWNLOAD_PDF_SUCESSO = 'DOWNLOAD_PDF_SUCESSO'
export const DOWNLOAD_PDF_ERROR = 'DOWNLOAD_PDF_ERROR'
export const DOCUMENTO_VALIDO = 'DOCUMENTO_VALIDO'
export const DOCUMENTO_INVALIDO = 'DOCUMENTO_INVALIDO'
export const DOCUMENTO_EXAME_SOLICITADO_VALIDO = 'DOCUMENTO_EXAME_SOLICITADO_VALIDO'
export const DOCUMENTO_EXAME_SOLICITADO_INVALIDO = 'DOCUMENTO_EXAME_SOLICITADO_INVALIDO'
export const DOCUMENTO_TERMO_NAO_CONFORMIDADE_VALIDO = 'DOCUMENTO_TERMO_NAO_CONFORMIDADE_VALIDO'
export const validarDocumento = (payload, router) => async (dispatch) => {
  try {
    const response = await axios.post('/publico/validar-documento', {
      payload,
    })
    if (response.data.documentoValidado) {

      if (response.data.documentoValidado.id_exame_solicitado) {
        dispatch({
          type: DOCUMENTO_EXAME_SOLICITADO_VALIDO,
          documentoValidado: response.data.documentoValidado,
        })
      } else if (response.data.documentoValidado.id_termo_nao_conformidade) {
        dispatch({
          type: DOCUMENTO_TERMO_NAO_CONFORMIDADE_VALIDO,
          documentoValidado: response.data.documentoValidado,
        })
      }else{
        dispatch({
          type: DOCUMENTO_VALIDO,
          documentoValidado: response.data.documentoValidado,
        })
      }
    } else {
      dispatch({
        type: DOCUMENTO_INVALIDO,
      })
    }
    if (response.data.documentoValidado?.id_exame_solicitado) {
      router.history.push('/publico/validar-documento/documento/EXAME_SOLICITADO')
    } else if(response.data.documentoValidado?.id_termo_nao_conformidade) {
      router.history.push('/publico/validar-documento/documento/TERMO_NAO_CONFORMIDADE')
    }else if(response.data.documentoValidado?.id_vestigio){
      router.history.push('/publico/validar-documento/documento/VESTIGIO')
    } else {
      router.history.push('/publico/validar-documento/documento/EXAME_REALIZADO')
    }
  } catch (error) {
    console.log(error)
    dispatch(criarAlerta(error.response, router, '/publico/validar-documento'))
  }
}
